import React from 'react';
import { formatExternalUrl } from '../../utils/formatUrl';
import {
    Box,
    Button,
    Popover,
    List,
    ListItem,
    Typography,
    Chip,
    Alert
} from "@mui/material";
import {
    Warning as AlertTriangleIcon,
    CheckCircle as CheckCircleIcon,
    Error as ErrorIcon,
    KeyboardArrowDown as KeyboardArrowDownIcon,
    KeyboardArrowUp as KeyboardArrowUpIcon
} from "@mui/icons-material";
import { colors, typography } from "../../styles/globals.js";
import { dummy_popover_list_data } from '../../mock.js';

const styles = {
    tabIcon: {
        width: "16px",
        height: "16px"
    },
    sourceButton: {
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: 300,
        height: '32px',
        minWidth: '100px',
        padding: '6px 16px',
        backgroundColor: '#FFFFFF',
        color: '#0E1944',
        borderRadius: '9999px',
        border: '1.5px solid #E2E6F0',
        transition: 'all 0.2s ease',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#F9FAFB',         // faint hover bg
            borderColor: '#D0D5E0'
        },
        '&:active': {
            backgroundColor: '#F0F4F8',         // pressed state
            borderColor: '#BFC6D4'
        }
    },
    popoverBox: {
        maxWidth: 500,
        maxHeight: 300,
        overflowY: 'auto',
        backgroundColor: colors.white,
        color: 'black',
        padding: "8px"
    },
    popoverList: {
        px: 2
    },
    popoverItem: {
        display: "flex",
        alignItems: "center",
        padding: "4px"
    },
    popoverListItem: {
        px: 1
    }
};

const ContactRow = ({ value, icon, hasRisk, buttonName = "Source", disabled = false, isInput = false }) => {
    const [popoverOpen, setPopoverOpen] = React.useState(false);
    const popoverRef = React.useRef(null);
    const isSourceButton = buttonName === "Source";

    const handleButtonClick = (e) => {
        if (isSourceButton && !disabled) {
            popoverRef.current = e.currentTarget;
            setPopoverOpen(prevOpen => !prevOpen);
        } else if (buttonName === "Open link") {
            // Extract URL from value - assuming value is the URL string
            const url = typeof value === 'string' ? value : value.toString();
            window.open(formatExternalUrl(url), '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    {icon}
                    <Typography
                        sx={{
                            color: "#676E8B",
                            fontWeight: typography.fontWeights.regular,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            maxWidth: '400px'
                        }}
                    >
                        {value}
                    </Typography>
                    {hasRisk ? <AlertTriangleIcon sx={{ ...styles.tabIcon, color: colors.warning }} /> : null}
                    {isInput && (
                        <Chip
                            label="Input Data"
                            sx={{
                                backgroundColor: '#e3f2fd',
                                color: '#1565c0',
                                fontSize: '12px',
                                fontWeight: 500,
                                height: '28px',
                                borderRadius: '14px',
                                flexShrink: 0
                            }}
                        />
                    )}
                </Box>
                {!isSourceButton && (
                    <Button
                        variant="outlined"
                        size="small"
                        disabled={disabled}
                        sx={styles.sourceButton}
                        onClick={handleButtonClick}
                    >
                        <Typography sx={{ color: colors.primary, fontSize: typography.fontSizes.regular, textAlign: "center" }}>{buttonName}</Typography>
                    </Button>
                )}
            </Box>
            {/* {isSourceButton && (
                <Popover
                    open={popoverOpen}
                    anchorEl={popoverRef.current}
                    onClose={handleButtonClick}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    slotProps={{
                        paper: {
                            sx: {
                                mt: 0.5 // 4px margin top (0.5 * 8px)
                            }
                        }
                    }}
                >
                    <Box sx={styles.popoverBox}>
                        <List sx={styles.popoverList}>
                            {_.map(dummy_popover_list_data, (item) => (
                                <Box key={item.id} sx={styles.popoverItem}>
                                    {item.hasError ? <ErrorIcon color="error" /> : <CheckCircleIcon color="success" />}
                                    <ListItem sx={styles.popoverListItem}>{item.id}</ListItem>
                                </Box>
                            ))}
                        </List>
                    </Box>
                </Popover>
            )} */}
        </>
    );
};

export default ContactRow;